<template>
  <transition
    appear
    name="changeCard position-absolute"
    appear-active-class="zoomInLeft"
    :enter-active-class="inAnimation"
    :leave-active-class="outAnimation"
    v-on:after-enter="handleResize"
  >
    <div
      v-if="this.viewState.currentQuestion == this.cardData.qName || this.viewState.showAll"
      class="card card2 p-2 animated position-absolute text-center"
      ref="card"
    >
      <div class="d-flex flex-column h-100 justify-content-between" style="min-height: 300px">
        <resize-observer @notify="handleResize" />
        <h2 class="flex-grow-1">{{this.cardData.qText}}</h2>
        <div
          v-if="this.cardData.qInstructions"
          class="px-5 flex-grow-1 instructiontext"
          v-html="this.cardData.qInstructions"
        ></div>
        <div v-if="this.cardData.qInstructionPicture">
          <img class="instruction-image m-2" :src="image" />
        </div>
        <div class="embed-responsive embed-responsive-16by9" v-if="this.cardData.qInstructionVideo">
          <iframe
            class="embed-responsive-item"
            :src="this.cardData.qInstructionVideo"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
        <div
          class="answers-wrapper w-100 flex-row justify-content-center d-flex align-content-center flex-grow-1"
        >
          <PictureAnswer
            v-for="(answer,index) in this.cardData.answers"
            :key="index"
            :optionName="answer.aName"
            :optionText="answer.aText"
            :optionValue="answer.aValue"
            :optionPicture="answer.aPicture"
            :optionSize="answersize"
            @optionSelected="optionSelected"
          ></PictureAnswer>
        </div>
        <div class="text-center flex-grow-1">
          <button
            class="btn-info m-2"
            @click="GoToPreviousCard"
            :disabled="viewState.previousQuestions.length < 1"
          >Previous Question</button>
          <button class="m-2 btn-info" @click="ResetModel">Start Over</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import PictureAnswer from './PictureAnswer.vue';

export default {
  props: { cardData: {}, viewState: {} },

  computed: {
    inAnimation() {
      return this.viewState.navigateForward ? 'zoomInLeft' : 'zoomInRight';
    },
    outAnimation() {
      return this.viewState.navigateForward ? 'zoomOutRight' : 'zoomOutLeft';
    },
    image() {
      const images = require.context('@/images');
      return images(`./${this.cardData.qInstructionPicture}`);
    },
    answersize() {
      return this.cardData.qInstructionPicture
        || this.cardData.qInstructionVideo
        ? 'smaller'
        : 'larger';
    },
  },
  components: { PictureAnswer },
  methods: {
    optionSelected(result) {
      this.$emit('complete', {
        name: this.cardData.qName,
        value: result.selectedValue,
      });
    },
    GoToPreviousCard() {
      this.$emit('GoToPreviousCard');
    },
    ResetModel() {
      this.$emit('Reset');
    },
    handleResize() {
      console.log(this.$refs.card.clientHeight);
      if (
        Math.abs(
          this.viewState.currentCardHeight - this.$refs.card.clientHeight,
        ) > 10
      ) {
        this.$emit('cardHeight', this.$refs.card.clientHeight);
      }
    },
  },
  mounted() {
    if (this.$refs.card) {
      this.handleResize();
    }
    // console.log(this.$refs.card.clientHeight);
    // this.handleResize();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  font-family: "Muli", Arial, Helvetica, sans-serif;
  color: #009ee2;
  margin: 10px;
}

.page {
  height: 100% !important;
  display: flex;
  align-items: center;
  text-align: center;
}
/* .card {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 768px;

  height: 600px;
  background-color: #ffffff;
  border-radius: 5px;
} */
.card2 {
  background-color: #ffffff;
  border-radius: 5px;
  display: block;
  width: 650px;
  min-height: 300px;
  margin: 10px auto;
  padding: 10px;
}

.fullheight {
  margin-bottom: -99999px;
  padding-bottom: 99999px;
}
.wrap-column {
  overflow: hidden;
}
.instruction-image {
  width: 60%;
}

.video-card {
  width: 90%;
}

@media screen and (max-width: 768px) {
  .card2 {
    width: 90%;
    height: auto;
  }
}
</style>
